import styled from 'styled-components';

export const Root = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Text = styled.span`
`;

export const Input = styled.input`
  background-color: #FFFFFF99;
`;

export const ActionsContainer = styled.div`
  display: flex;
  margin-left: 10px;
`;

export const ButtonContainer = styled.div`
  padding: 3px;
`;

export const EditIconContainer = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  margin-left: 7px;
  &:hover {
    background-color: rgba(18, 36, 66, 0.05);
  }
`;

